import React from "react";
import { withRouter } from "react-router-dom"
import Sidebar from "../../Components/sidebar/sidebar"
import OrdersComponent from "../../Components/orders/orders"
import MobileNavBar from "../../Components/mobileNavbar/navbar"
import style from "../sidebarPage.module.scss"

const OrdersPage = (props) => {
    return (
        <div className={style.wrapper}>
            <div className={style.mobileNavBar}>
                <MobileNavBar />
            </div>
            <div className={style.content}>
                <OrdersComponent user={props.user} />
            </div>
            <div className={style.sidebar}>
                <Sidebar user={props.user} />
            </div>
        </div>
    )
}
export default withRouter(OrdersPage);



